<template>
  <v-dialog v-model="show" width="450" @click:outside="onClickCancel">
    <v-card>
      <div class="header-icon-wrapper">
        <v-icon color="blue darken-2">mdi-account-multiple</v-icon>
      </div>
      <div class="wrapper-title">
        <h3>{{ $t("startingConversation") }}</h3>
        <div>{{ fullName }}</div>
      </div>
      <div class="process-main-actions">
        <v-btn outlined large color="primary" @click="onClickCancel">
          {{ $t("doCancel") }}</v-btn
        >
        <v-btn large color="primary" @click="onClickJoin">{{
          $t("continue")
        }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import JoiningVideoCallDialog from "./mixin/JoiningVideoCallDialog";

export default {
  mixins: [JoiningVideoCallDialog],
};
</script>

<style lang="scss" scoped>
$primaryColor: #3fa2f7;

.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 3rem;
    padding: 25px;
    border-radius: 50%;
    border: 4px solid #3fa2f7;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
.process-main-actions {
  text-align: center;
  padding-top: 6%;
  padding-bottom: 4%;
}
</style>



// WEBPACK FOOTER //
// src/components/JoiningVideoCallDialog.vue